<template>
  <ui-field
    :id="id"
    :label="label"
    :label-position="labelPosition"
    :bottom-margin="bottomMargin"
    :variant="variant"
    :error="dirtyError"
  >
    <ui-select
      :id="id"
      :type="type"
      :readonly="readonly"
      :value="value"
      :filterable="filterable"
      :required="required"
      :options="options"
      v-on="inputListeners"
    />
  </ui-field>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    type: { type: String, default: "text" },
    filterable: Boolean,
    variant: {
      type: String,
      validator: val => ["default", "success", "error"].includes(val),
      default: "default"
    },
    error: String,
    label: String,
    labelPosition: String,
    bottomMargin: { type: String },
    readonly: [String, Boolean],
    required: [String, Boolean],
    value: String,
    options: { type: Array, required: true }
  },
  data() {
    return {
      dirty: false,
      modified: false,
      submitted: false
    };
  },
  computed: {
    dirtyError() {
      if (this.dirty || this.submitted) {
        return this.error;
      } else {
        return null;
      }
    },
    inputListeners() {
      return {
        ...this.$listeners,
        input: event => {
          this.modified = true;
          this.$emit("input", event);
        },
        blur: event => {
          if (this.modified) {
            this.dirty = true;
          }
          this.$emit("blur", event);
        }
      };
    }
  },
  methods: {
    onFormSubmit() {
      this.submitted = true;
    }
  },
  mounted() {
    this.form = this.$el.closest("form");
    this.form?.addEventListener("submit", this.onFormSubmit);
  },
  beforeDestroy() {
    this.form?.removeEventListener("submit", this.onFormSubmit);
  }
};
</script>
